"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlSanitizer = exports.formatBytes = exports.compactNumberFormatter = exports.numberUnitFormatter = exports.THRESHOLD_VAL = void 0;
var sanitize_html_1 = __importDefault(require("sanitize-html"));
// Threshold value for click count before applying compact notations.
exports.THRESHOLD_VAL = 9999999;
/**
 * Takes in a number and format in into a compact form without rounding.
 * This method takes reference to a constant threshold value, and only compact
 * values that exceed this threshold.
 *
 * @param numberToFormat Number to format.
 * @returns The formatted string with the compact notations.
 */
function numberUnitFormatter(numberToFormat) {
    var getNotation = function () {
        if (numberToFormat >= 1000000000000)
            return 't';
        if (numberToFormat >= 1000000000)
            return 'b';
        if (numberToFormat >= 1000000)
            return 'm';
        return '';
    };
    if (numberToFormat <= exports.THRESHOLD_VAL) {
        var numberFormatter = new Intl.NumberFormat('en-US');
        return numberFormatter.format(numberToFormat);
    }
    var compactNumber = numberToFormat;
    while (compactNumber >= 1000) {
        compactNumber = Math.floor(compactNumber / 1000);
    }
    return compactNumber + getNotation();
}
exports.numberUnitFormatter = numberUnitFormatter;
/**
 * Takes in a number and format in into a compact form without rounding.
 *
 * @param numberToFormat Number to format.
 * @returns The formatted string with the compact notations.
 */
function compactNumberFormatter(numberToFormat) {
    var getNotation = function () {
        if (numberToFormat >= 1000000000000)
            return 't';
        if (numberToFormat >= 1000000000)
            return 'b';
        if (numberToFormat >= 1000000)
            return 'm';
        if (numberToFormat >= 1000)
            return 'k';
        return '';
    };
    var compactNumber = numberToFormat;
    while (compactNumber >= 1000) {
        compactNumber = Math.floor(compactNumber / 1000);
    }
    return compactNumber + getNotation();
}
exports.compactNumberFormatter = compactNumberFormatter;
/**
 * Takes in numerical bytes and apply compact notations to it.
 *
 * @param bytes The bytes for format.
 */
function formatBytes(bytes) {
    if (bytes === 0)
        return '0b';
    var k = 1024;
    var sizes = ['b', 'kb', 'mb', 'gb'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "" + parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
}
exports.formatBytes = formatBytes;
function htmlSanitizer(dirtyHtmlString) {
    return sanitize_html_1.default(dirtyHtmlString, {
        allowedTags: ['b', 'i', 'em', 'strong', 'a'],
        allowedAttributes: {
            a: ['href', 'target', 'rel', 'style'],
        },
        allowedStyles: {
            '*': {
                // Match HEX and RGB
                color: [
                    /^#(0x)?[0-9a-f]+$/i,
                    /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                ],
                'text-decoration': [/^underline$/],
            },
        },
    });
}
exports.htmlSanitizer = htmlSanitizer;
exports.default = new Intl.NumberFormat();
